import React from 'react'
import EditRegister from '../../../components/editregister/EditRegister'
export const ClientEditProfile = () => {
  return <EditRegister />
}
